export const HOME = 'Home';
export const BROADCASTS = 'Events';
export const BROADCASTSADD = 'Create a live event';
export const BROADCASTSUPDATE = 'Create a live event';
export const EMBED = 'Embed';
export const MEDIA = 'Media Center';
export const REPORTS = 'Reports';
export const DETAILEDREPORTS = 'Detailed Reports';
export const SOURCES = 'Sources';
export const SETTINGS = 'Settings';
export const ACCOUNT = 'Account';
export const PERFERENCES = 'Perferences';
export const BILLING = 'Billing';
export const RESOURCES = 'Resources';
export const USERS = 'Users';
export const PLANS = 'Plans';
export const COMMISSION = 'Commission';
export const PREFERENCES = 'Preferences';
export const INTEGRATIONS = 'Integrations';
export const PAYMENT = 'Payment';
export const STORAGE = 'Storage';
export const APIKEYS = 'Api Keys';
export const APPEARANCE = 'Preferences';
export const DESTINATIONS = 'Destinations';
export const THEMES = 'Themes';
export const THEMES_DETAIL = 'Themes-detail';
export const URL_OVERLAY = 'URL Overlays';
export const OVERLAYS_LIBRARY = 'Overlays Library';
export const MY_OVERLAYS = 'My Overlays';
export const MY_COMPOSITIONS = 'My Compositions';
export const VIDEO_TUTORIALS = 'Video Tutorials';

export const BROADCAST_SOURCES = 'Sources';
export const BROADCAST_OVERVIEW = 'Overview';
export const BROADCAST_DESTINATIONS = 'Destinations';
export const BROADCAST_DIAGNOSTICS = 'Diagnostics';
export const BROADCAST_ANALYTICS = 'Analytics';
export const BROADCAST_DOCUMENTS = 'Documents';
export const BROADCAST_CHAT = 'Comments';
export const BROADCAST_CHAT_COMMENT = 'Comments';
export const BROADCAST_CHAT_HIDDEN = 'Hiddenner';
export const BROADCAST_REPORT = 'Report';
export const BROADCAST_REPORT_LIVE_DATA = 'Live Data';
export const BROADCAST_REPORT_VIEWERS_DATA = 'Viewers Data';
export const BROADCAST_REPORT_STREAM_DATA = 'Stream Analytics';
export const BROADCAST_TRIM = 'Trim Recording';
export const BROADCAST_CLIPS = 'Highlight Clips';
export const BROADCAST_OVERLAYS = 'Overlays';
export const BROADCAST_SCOREBOARD = 'Scoreboard';
